<template>
  <div>
    <el-card shadow="always">
      <EditForm ref="main" :platformCode="params.code" :disabled="disabled" />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-sys-thirdPartyApiSet-detail',
  components: { EditForm },
  props: {
    menuType: { type: String, default: '' },
    platformCode: { type: String, default: '' },
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
  methods: {},
}
</script>
